<template>
    <div style="margin-top: 30px;margin-left: 85px;margin-right: 85px;margin-bottom: 30px;">
        <a-layout>
            <a-layout-content style="padding-left: 83px;background:#fff">
                <div style="background-color:rgb(204 204 204 / 0.25);;padding:20px">
                    <div style="display:flex;justify-content: center;padding-bottom:30px">
                        <h3>Company Information</h3>
                    </div>
                <a-form-model
                ref="AddCompanyInfoform"
                :model="companyInfoform"
                :rules="rules"  
            >
                
                <a-row type="flex" justify="space-around">
                    <a-col :span="9">
                         <a-form-model-item label="Business Type" ref="businessType" prop="businessType">
                            <a-select @change="onChangeBusinessType" class="dropdownItem selecInput" v-model="companyInfoform.businessType" placeholder="please select your option">
                                <a-select-option value="0">
                                    Individual
                                </a-select-option> 
                                <a-select-option value="1">
                                    Limited liability
                                </a-select-option> 
                            </a-select>
                        </a-form-model-item>
                     </a-col>
                     <a-col :span="9" >
                        <a-form-model-item v-show="showBusinessRegNumber" label="Business Registration Number" ref="businessRegNumber" prop="businessRegNumber">
                            <a-input 
                                v-model="companyInfoform.businessRegNumber"
                            />
                        </a-form-model-item>
                    </a-col>
        
                </a-row>
                 <a-row type="flex" justify="space-around">
                    <a-col :span="9">
                        <a-form-model-item label="Trade Name" ref="companyName" prop="companyName">
                            <a-input 
                                v-model="companyInfoform.companyName"
                            />
                        </a-form-model-item>
                    </a-col>
                
                    <a-col :span="9" >
                        <a-form-model-item label="Business Phone Number" ref="businessNumber" prop="businessNumber">
                            <a-input 
                                v-model="companyInfoform.businessNumber"
                            />
                        </a-form-model-item>
                    </a-col>
                </a-row>
                <a-row type="flex" justify="space-around">
                    <a-col :span="9" >
                        <a-form-model-item label="First Name" ref="firstName" prop="firstName">
                            <a-input 
                                v-model="companyInfoform.firstName"
                            />
                        </a-form-model-item>
                    </a-col>
                    
                     <a-col :span="9" >
                        <a-form-model-item label="Last Name" ref="lastName" prop="lastName">
                            <a-input 
                                v-model="companyInfoform.lastName"
                            />
                        </a-form-model-item>
                    </a-col>
                    
                </a-row>
                <a-row type="flex" justify="space-around">
                    <a-col :span="9" >
                        <a-form-model-item label="Address" ref="address" prop="address">
                            <a-input 
                                v-model="companyInfoform.address"
                            />
                        </a-form-model-item>
                    </a-col>
                    
                     <a-col :span="9" >
                        <a-form-model-item label="Years in Busines" ref="yearsInBusiness" prop="yearsInBusiness">
                            <a-input 
                                v-model="companyInfoform.yearsInBusiness"
                            />
                        </a-form-model-item>
                    </a-col>
                    
                </a-row>

                <a-row type="flex" justify="space-around">
                    <a-col :span="21" >
                        <a-form-model-item label="TIN Number" ref="tin" prop="tin">
                            <a-input 
                                v-model="companyInfoform.tin"
                            />
                        </a-form-model-item>
                    </a-col>
                    
                    
                </a-row>
                
                <div style="display:flex;justify-content: center;padding-bottom: 10px;">
                    <a-spin class="spinner" :spinning="loading" />
                </div>
          
            <a-form-model-item style="display: flex;justify-content: center;align-items: center;padding-top:50px;">
                <a-button @click="handleSubmit"  style="background: #418a49;height:45px;color:#fff;width:256px;">
                    Save & Continue
                </a-button>
            </a-form-model-item>
        </a-form-model>
                    
            </div>
            </a-layout-content>
        </a-layout>
    </div>
</template>

<script>
import {  mapActions,mapGetters } from 'vuex';
    export default {
        name: "Steps",
        data() {
            return {
                
                companyInfoform:{
                    companyName:"",
                    address:"",
                    businessNumber:"",
                    yearsInBusiness:"",
                    businessRegNumber:"",
                    firstName:"",
                    lastName:"",
                    tin:"",
                    businessType:""
                },
                showBusinessRegNumber:false,
                loading: false,
                rules: {
                    companyName: [
                        { required: true, message: 'Please enter your trade name' , trigger: 'change'},
                    ],
                    
                    businessRegNumber: [
                        { required: false, message: 'Please enter your business registration number' , trigger: 'change'},
                        // {   
                        //     pattern: new RegExp(/^[1-9]\d*$/), 
                        //     message: 'Please enter valid number', 
                        //     trigger: 'change'
                        // },
                    ],
                    businessType: [
                        { required: true, message: 'Please choose your choice' , trigger: 'change'},
                    ],
                    
                    firstName: [
                        { required: true, message: 'Please enter your first name' , trigger: 'change'},
                    ],
                    
                    lastName: [
                        { required: true, message: 'Please enter your last name' , trigger: 'change'},
                    ],
                    
                    yearsInBusiness: [
                        { required: true, message: 'Please enter your years in business' , trigger: 'change'},
                        // { min: 4, message: 'Please years should be 4 digits' , trigger: 'change'},
                        // { max: 4, message: 'Please years should be 4 digits' , trigger: 'change'},
                        {   
                            pattern: new RegExp(/^[1-9]\d*$/), 
                            message: 'Please enter valid number', 
                            trigger: 'change'
                        },
                    ],
                    businessNumber: [
                        { required: true, message: 'Please enter your business number' , trigger: 'change'},
                    ],
                    address: [
                        { required: true, message: 'Please enter your company address' , trigger: 'change'},
                        
                    ],       
                    tin: [
                        { required: true, message: 'Please enter your tin' , trigger: 'change'},
                    ],
                },
            };
        },
        computed: {
            ...mapGetters(['getStepCount'])
        },
        methods: {
            ...mapActions(['setStepCount','onboardingBusinesCompany']),
            handleSubmit(){
                this.$refs.AddCompanyInfoform.validate(valid => {
                    if (valid) {
                        this.loading = true;
                        let request_data = {
                            businessInfo:{
                                firstName: this.companyInfoform.firstName,
                                lastName: this.companyInfoform.lastName,
                                yearsInBusiness: parseInt(this.companyInfoform.yearsInBusiness)
                            },
                            companyInfo:{
                                address:this.companyInfoform.address,
                                businessNumber: this.companyInfoform.businessNumber,
                                tradeName:this.companyInfoform.companyName,
                                tin: this.companyInfoform.tin,
                                businessType: parseInt(this.companyInfoform.businessType),
                                businessRegNumber: this.companyInfoform.businessRegNumber ? this.companyInfoform.businessRegNumber : ""
                            }
                        }
                        // console.log("request_data | ", request_data)
                        
                        this.onboardingBusinesCompany(request_data).then(response => {
                            
                            
                            this.loading = false;
                            if(response[0].status === 200 && response[1].status === 200 ){
                                this.showSuccessAlert("Company Details Added Successfully")
                                this.$refs.AddCompanyInfoform.resetFields();
                                this.$router.push(`/setup-shop`).catch(()=>{});
                            }else{
                                this.loading = false;
                                // console.log("Error | ", response)
                                this.showErrorAlert("Something went wrong, try again later.")
                            }
                        },
                        error =>{
                            this.loading = false
                            console.log("Error | ", error)
                            this.showErrorAlert("Something went wrong, try again later.")
                        })
                    }else {
                        return false;
                    }
                })
            },
            onChangeBusinessType(value){
                // console.log("value | ", value)
                if(value === "1"){
                    this.showBusinessRegNumber = true
                }else{
                    this.showBusinessRegNumber = false
                }
            },
            showSuccessAlert(message) {
                this.$notification['success']({
                    message: message,
                });
            },
            showErrorAlert(message) {
                this.$notification['error']({
                    message: message
                });
            },
            
        },
        created(){
            // if(this.getStepCount){
            //     this.current = this.getStepCount
            // }
        },
        updated(){
            // if(this.getStepCount){
            //     this.current = this.getStepCount
            // }
        }
    }
</script>

<style scoped>
.ant-layout-sider{
    background: #FFFFFF;
}
.slider >>> .ant-steps-item-process .ant-steps-item-icon {
    background: #418a49;
}
.slider >>> .ant-steps-item-process .ant-steps-item-icon {
    border-color: #418a49;
}
.slider >>> .ant-steps-item-process .ant-steps-item-icon:hover {
    color: #418a49;
}
.slider >>> .ant-steps-item-finish .ant-steps-item-icon {
    background-color: #fff;
    border-color: #418a49;
}
.slider >>> .ant-steps-item-finish .ant-steps-item-icon > .ant-steps-icon {
    color: #418a49;
}
.slider >>> .ant-steps-item-finish > .ant-steps-item-container > .ant-steps-item-tail::after {
    background-color: #418a49;
}
.slider {
    flex: none !important; 
    max-width: none !important;
    min-width: none !important;
    width: 250px !important;
}

</style>